<a *ngIf="modal">
	<span class="material-icons float-right px-4 pt-2" (click)="back()">close</span>
</a>
<div class="row px-4 pt-2" *ngIf="modal">
	<div class="col">
		<h2 class="fw-bold">Criação de Grupo de usuário</h2>
	</div>
</div>

<div class="" [ngClass]="{ 'card p-5': !modal, 'px-5 pt-1 pb-5': modal }">
	<form [formGroup]="form" (ngSubmit)="save(form)">
		<div class="row">
			<div class="col-6">
				<mat-form-field>
					<mat-label>Nome Perfil</mat-label>
					<input matInput formControlName="name" />
					<mat-error *ngIf="form.get('name').invalid">O nome deve ter pelo menos 3 caracteres</mat-error>
				</mat-form-field>
			</div>
		</div>
		<div class="row border rounded p-3 my-2" *ngFor="let classification of gruop.classifications">
			<div class="col p-3">
				<app-eligible
					[modal]="modal"
					(evtSelectedMasterCompany)="testMasterCompany($event)"
					[classification]="classification"
					(remove)="remove($event)"
					[modalFlag]="modal"
				></app-eligible>
				<!--<div class="row" *ngIf="classification.companyIds.length <= 0 &&  flagFormSubmitted">
          <div class="col">
            Selecione uma empresa pelo menos.
          </div>
        </div>-->
			</div>
		</div>
		<div class="row my-1">
			<div class="col-12 p-0">
				<button type="button" class="btn w-100 btn-outline-secondary border-color" (click)="add()">
					<span class="material-icons"> add </span>
				</button>
			</div>
		</div>
		<div class="row" *ngIf="flagFormSubmitted && gruop.classifications.length <= 0">
			<div class="col">Insira um grupo pelo menos.</div>
		</div>

		<div class="row mt-5">
			<div class="col">
				<button class="btn mx-2" [ngClass]="{ 'btn-primary': !modal, 'btn-secondary': modal }" type="submit">
					SALVAR
				</button>
				<button class="btn btn-secondary mx-2" type="button" (click)="back()">CANCELAR</button>
			</div>
		</div>
	</form>
</div>
